import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import { Icon } from '@/components/Icon';
import { Popover, } from '@/components/Popover/Popover';
import { baseButtonProps, Button, } from './Button';
/**
 * Accessible icon-only button.
 *
 * @deprecated So that we think twice before we use this in new components, where
 * in reality we should design our buttons with a proper label, or use an action menu.
 */
export const IconButton = tsx.componentFactoryOf().create({
    name: 'icon-button',
    inheritAttrs: false,
    props: {
        ...baseButtonProps,
        /** Override default to `neutral`, see {@link baseButtonProps}. */
        semantic: p.ofType().default('neutral'),
        /** Override default to 1, see {@link baseButtonProps}. */
        prominence: p.ofType().default(1),
        /** @inheritdoc */
        labeledIcon: p.ofType().required,
    },
    methods: {
        /**
         * @returns Rendered icon button with aria label.
         */
        renderButtonNode(tooltipData) {
            const props = {
                ...this.$propsTyped,
                ariaLabel: this.labeledIcon.label,
            };
            return (<Button attrs={this.$attrs} props={props} class={[this.$vnode.data?.class, this.$vnode.data?.staticClass]} style={[this.$vnode.data?.style, this.$vnode.data?.staticStyle]} 
            // Tooltip popover attributes
            nativeOnBlur={tooltipData?.hide} nativeOnFocus={tooltipData?.show} nativeOnMouseenter={tooltipData?.show} nativeOnMouseleave={tooltipData?.hide}>
                    <Icon icon={this.labeledIcon.icon}/>
                </Button>);
        },
    },
    /** @returns Rendered icon button, with possible tooltip. */
    render() {
        return (<Popover popoverAttrs={{ class: 'px-2 py-1' }} placement={this.labeledIcon.placement} scopedSlots={{
                button: tooltipData => this.renderButtonNode(tooltipData),
                popover: () => this.labeledIcon.label,
            }}/>);
    },
});
